import { baseURL, axiosInstance, aqferDBDSURL, aqferGraphDSURL } from './axios';

const api = {
  login: body => {
    return axiosInstance.post(`${baseURL}/auth/token/`, body);
  },
  getUserProfile: () => {
    return axiosInstance.get(`${baseURL}/api/users/profile/`);
  },
  startSession: () => {
    return axiosInstance.post(`${baseURL}/api/users/start_session/`);
  },
  changeDefaultClient: body => {
    return axiosInstance.put(`${baseURL}/api/users/switch_company/`, body);
  },
  getAllConfigurationForClient: params => {
    return axiosInstance.get(`${baseURL}/api/di/?${params}`);
  },
  validateConfiguration: (body, queryParams = '') => {
    const url = queryParams
      ? `${baseURL}/api/di/validate-json/?${queryParams}`
      : `${baseURL}/api/di/validate-json/`;
    return axiosInstance.post(url, body, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  createConfiguration: (body, queryParams = '') => {
    const url = queryParams
      ? `${baseURL}/api/di/?${queryParams}`
      : `${baseURL}/api/di/`;
    return axiosInstance.post(url, body, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getConfiguration: configId => {
    return axiosInstance.get(`${baseURL}/api/di/${configId}/`);
  },
  updateConfiguration: (configId, body, queryParams = '') => {
    const url = queryParams
      ? `${baseURL}/api/di/${configId}/?${queryParams}`
      : `${baseURL}/api/di/${configId}/`;
    return axiosInstance.put(url, body, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  deleteConfiguration: configId => {
    return axiosInstance.delete(`${baseURL}/api/di/${configId}/`);
  },
  updateAttributePriorities: body => {
    return axiosInstance.put(
      `${baseURL}/api/data_quality/update-precedence/`,
      body
    );
  },
  updateUserProfile: body => {
    return axiosInstance.put(`${baseURL}/api/users/update_profile/`, body);
  },
  updateUsersProfile: (userId, body) => {
    return axiosInstance.patch(`${baseURL}/api/users/${userId}/`, body);
  },
  updateUserRole: (userId, body) => {
    return axiosInstance.post(`${baseURL}/api/users/${userId}/roles/`, body);
  },
  deleteUserRole: (userId, body) => {
    return axiosInstance.delete(`${baseURL}/api/users/${userId}/roles/`, {
      data: body,
    });
  },
  changePassword: body => {
    return axiosInstance.put(`${baseURL}/api/users/chg_pwd/`, body);
  },
  getAllUsers: params => {
    return axiosInstance.get(`${baseURL}/api/company_users/?${params}`);
  },
  getAllRoles: body => {
    return axiosInstance.get(`${baseURL}/api/roles/`);
  },
  getUserRoles: userId => {
    return axiosInstance.get(`${baseURL}/api/users/${userId}/roles/`);
  },
  createNewUser: body => {
    return axiosInstance.post(`${baseURL}/api/users/`, body);
  },
  deleteUser: userId => {
    return axiosInstance.delete(`${baseURL}/api/users/${userId}/`);
  },
  getOperators: () => {
    return axiosInstance.get(
      `${baseURL}/api/airflow/operators/operators_list_db`
    );
  },
  generateDAG: body => {
    return axiosInstance.post(`${baseURL}/api/airflow/dag/generate`, body);
  },

  addExternalUser: body => {
    return axiosInstance.post(`${baseURL}/api/users/add_external_user/`, body);
  },
  deleteExternalUserMapping: userExternalId => {
    return axiosInstance.delete(
      `${baseURL}/api/user_mapping/${userExternalId}/`
    );
  },
  updateExternalUser: body => {
    return axiosInstance.put(
      `${baseURL}/api/users/update_external_user/`,
      body
    );
  },
  getAirflowUsers: () => {
    return axiosInstance.get(
      `${baseURL}/api/user_mapping/external_users/?external_server_type=1`
    );
  },
  getSupersetUsers: () => {
    return axiosInstance.get(
      `${baseURL}/api/user_mapping/external_users/?external_server_type=2`
    );
  },
  addAWSCredentials: body => {
    return axiosInstance.post(
      `${baseURL}/api/companyaws/add_company_aws_credentials/`,
      body
    );
  },

  addClientSettings: (clientId, body) => {
    return axiosInstance.put(`${baseURL}/api/companies/${clientId}/`, body);
  },
  getClientSettings: clientId => {
    return axiosInstance.get(`${baseURL}/api/companies/${clientId}/`);
  },
  getClientCredentials: clientId => {
    return axiosInstance.get(`${baseURL}/api/companyaws/${clientId}/`);
  },
  getAllCompanies: () => {
    return axiosInstance.get(`${baseURL}/api/companies/`);
  },
  createCompany: body => {
    return axiosInstance.post(`${baseURL}/api/companies/`, body);
  },
  getAllDags: () => {
    return axiosInstance.get(`${baseURL}/api/dags/`);
  },
  saveDag: body => {
    return axiosInstance.post(`${baseURL}/api/dags/`, body);
  },
  deleteDag: dagId => {
    return axiosInstance.delete(`${baseURL}/api/dags/${dagId}/`);
  },
  getDag: dagId => {
    return axiosInstance.get(`${baseURL}/api/dags/${dagId}/`);
  },
  editDag: (dagId, body) => {
    return axiosInstance.patch(`${baseURL}/api/dags/${dagId}/`, body);
  },
  getJSONConfigFromCloudStorage: (
    type,
    is_schema_edit,
    body,
    id = null,
    isDqh = false
  ) => {
    return axiosInstance.post(
      `${baseURL}/api/storage/get-json/?storage_type=${type}&is_schema_edit=${is_schema_edit}${
        id ? '&connector_id=' + id : ''
      }${isDqh ? '&type=dqh' : ''}`,
      body,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
  },
  getJSONConfigFromDataWarehouse: (type, objectName) => {
    return axiosInstance.post(
      `${baseURL}/api/storage/get-json/?storage_type=${type}&object_name=${objectName}`
    );
  },
  searchFileString: (
    type,
    bucket,
    query,
    id,
    mailboxName = null,
    fileKind = null,
    signal = null
  ) => {
    return axiosInstance.get(
      `${baseURL}/api/storage/object-storage/?storage_type=${type}&operation=search_by_filename${
        bucket ? '&bucket_name=' + bucket : ''
      }${id ? '&connector_id=' + id : ''}${
        mailboxName ? '&mailbox_name=' + encodeURIComponent(mailboxName) : ''
      }&query_string=${encodeURIComponent(query)}${
        fileKind ? '&file_kind=' + encodeURIComponent(fileKind) : ''
      }`,
      signal ? { signal } : undefined
    );
  },
  resetPassword: body => {
    return axiosInstance.post(`${baseURL}/auth/password-reset/`, body);
  },
  verifyToken: token => {
    return axiosInstance.get(`${baseURL}/api/set-new-password/${token}/`);
  },
  setNewPassword: body => {
    return axiosInstance.post(`${baseURL}/api/set-new-password/`, body);
  },
  listTablesInDataWarehouse: (type, dataShare) => {
    return axiosInstance.get(
      `${baseURL}/api/storage/warehouse/?storage_type=${type}&operation=list_tables&datashare_name=${dataShare}`
    );
  },
  getAllNotifications: queryParams => {
    return axiosInstance.get(`${baseURL}/api/notification/?${queryParams}`);
  },
  getUserPreferences: (moduleName, gridTitle) => {
    return axiosInstance.get(
      `${baseURL}/api/user_preferences/?module_name=${moduleName}&grid_title=${gridTitle}`
    );
  },
  updateUserPreferences: body => {
    return axiosInstance.post(`${baseURL}/api/user_preferences/`, body);
  },
  markAsReadUnread: body => {
    return axiosInstance.put(
      `${baseURL}/api/notification/mark-read-unread/`,
      body
    );
  },
  markAllReadUnread: body => {
    return axiosInstance.put(
      `${baseURL}/api/notification/mark-all-read-unread/`,
      body
    );
  },
  testConnectionForCloudStorage: (type, connectorType, options = {}) => {
    const params = new URLSearchParams({
      storage_type: type,
      connector_type: connectorType,
    });
    if (options.bucketName) params.append('bucket_name', options.bucketName);
    if (options.cloud_region)
      params.append('cloud_region', options.cloud_region);
    if (options.storageAccount)
      params.append('storage_account', options.storageAccount);
    if (options.container) params.append('container', options.container);
    return axiosInstance.get(
      `${baseURL}/api/storage/test-connection/?${params.toString()}`
    );
  },
  testConnectionForPosthogStorage: (type, project_id, connectorType) => {
    return axiosInstance.get(
      `${baseURL}/api/storage/test-connection/?storage_type=${type}&project_id=${project_id}&connector_type=${connectorType}`
    );
  },
  testConnectionForSalesforceStorage: (type, clientId, connectorType) => {
    return axiosInstance.get(
      `${baseURL}/api/storage/test-connection/?storage_type=${type}&client_id=${clientId}&connector_type=${connectorType}`
    );
  },
  testConnectionForGaStorage: (type, property_id, connectorType) => {
    return axiosInstance.get(
      `${baseURL}/api/storage/test-connection/?storage_type=${type}&property_id=${property_id}&connector_type=${connectorType}`
    );
  },
  testConnectionForDataWarehouse: (type, datashare, connectorType) => {
    return axiosInstance.get(
      `${baseURL}/api/storage/test-connection/?storage_type=${type}&datashare_name=${datashare}&connector_type=${connectorType}`
    );
  },
  saveConnector: body => {
    return axiosInstance.post(`${baseURL}/api/connectors/`, body);
  },
  getAllConnectors: connectorType => {
    return axiosInstance.get(
      `${baseURL}/api/connectors/?connector_type=${connectorType}`
    );
  },
  getConnectorDetails: id => {
    return axiosInstance.get(`${baseURL}/api/connectors/${id}/`);
  },
  saveMftMailbox: body => {
    return axiosInstance.post(`${baseURL}/api/mft-mailbox/`, body);
  },
  getDashboardToken: (context = 'landing') => {
    return axiosInstance.get(
      `${baseURL}/api/companies/dashboard/?context=${context}`
    );
  },
  bulkUpdateStatus: body => {
    return axiosInstance.put(`${baseURL}/api/di/bulk-update-status/`, body);
  },
  getAqferEntityDetails: (type, domain, key) => {
    return axiosInstance.get(
      `${aqferDBDSURL}/entities/${type}~${domain}~${key}`
    );
  },
  getAqferEntityEdges: (type, domain, key) => {
    return axiosInstance.get(
      `${aqferGraphDSURL}/entities/${type}~${domain}~${key}/edges`
    );
  },
  getSpineGraphDetails: (type, value) => {
    return axiosInstance.get(
      `${baseURL}/api/spine/query?${type}=${value}&allow_multiple=true`
    );
  },
  getConsumerDetailsByIP: ip => {
    return axiosInstance.get(`${baseURL}/api/idms/consumer?plainIp=${ip}`);
  },
  getConsumerDetailsByHashedEmail: emailHash => {
    return axiosInstance.get(
      `${baseURL}/api/idms/consumer?hashedEmail=${emailHash}`
    );
  },
  getConsumerDetailsByIndividualID: id => {
    return axiosInstance.get(`${baseURL}/api/idms/consumer?individualId=${id}`);
  },
  generateFieldMapping: body => {
    return axiosInstance.post(
      `${baseURL}/api/storage/generate-field-mapping/`,
      body
    );
  },
  generatePysparkExpression: body => {
    return axiosInstance.post(
      `${baseURL}/api/storage/generate-pyspark-expression/`,
      body
    );
  },
  listSalesforceObjects: clientId => {
    return axiosInstance.get(
      `${baseURL}/api/storage/saas/?storage_type=SALESFORCE&operation=list_objects&client_id=${clientId}`
    );
  },
  getJSONConfigFromSalesforce: (clientId, objectName) => {
    return axiosInstance.post(
      `${baseURL}/api/storage/get-json/?storage_type=SALESFORCE&client_id=${clientId}&object_name=${objectName}`
    );
  },
  // Lookup search API
  lookupSearch: body => {
    return axiosInstance.post(`${baseURL}/api/search/`, body);
  },
  // Athena – Feed Data API (server-side pagination via limit/offset)
  getAthenaFeedData: (fileName, { limit = 10, offset = 0 } = {}) => {
    const params = new URLSearchParams({
      feed: fileName,
      limit: String(limit),
      offset: String(offset),
    });
    return axiosInstance.get(`${baseURL}/api/athena/feed_data/?${params}`);
  },
  // Athena – Data Profile API
  getDataProfile: feedName => {
    return axiosInstance.get(
      `${baseURL}/api/athena/data_profile/?feed=${feedName}`
    );
  },
  /** Match Output — corporate groups (em_match_ai_group) */
  getAthenaMatchAiGroups: () => {
    return axiosInstance.get(`${baseURL}/api/athena/match-ai-groups/`);
  },
  /** Match Output — row-level matches (em_match_ai_output_demo) */
  getAthenaMatchAiOutput: () => {
    return axiosInstance.get(`${baseURL}/api/athena/match-ai-output/`);
  },
  // Standardized Fields / Validation Rules APIs
  getStandardizedFields: () => {
    return axiosInstance.get(`${baseURL}/api/standardized-fields/`);
  },
  getStandardizedField: fieldId => {
    return axiosInstance.get(`${baseURL}/api/standardized-fields/${fieldId}/`);
  },
  createStandardizedField: body => {
    return axiosInstance.post(`${baseURL}/api/standardized-fields/`, body);
  },
  updateStandardizedField: (fieldId, body) => {
    return axiosInstance.put(
      `${baseURL}/api/standardized-fields/${fieldId}/`,
      body
    );
  },
  getValidationRulesByFieldId: fieldId => {
    return axiosInstance.get(
      `${baseURL}/api/validation-rules/?field_id=${fieldId}`
    );
  },
  getValidationRuleTypes: () => {
    return axiosInstance.get(
      `${baseURL}/api/validation-rules/validation-types/`
    );
  },
  getDpPilotFileHistory: () => {
    return axiosInstance.get(`${baseURL}/api/dp-pilot-file-history/`);
  },
  getValidationRule: ruleId => {
    return axiosInstance.get(`${baseURL}/api/validation-rules/${ruleId}/`);
  },
  createValidationRule: body => {
    return axiosInstance.post(`${baseURL}/api/validation-rules/`, body);
  },
  updateValidationRule: (ruleId, body) => {
    return axiosInstance.put(
      `${baseURL}/api/validation-rules/${ruleId}/`,
      body
    );
  },
  testValidationRule: body => {
    return axiosInstance.post(`${baseURL}/api/validation-rules/test/`, body);
  },
  generateValidationRuleExpr: body => {
    return axiosInstance.post(
      `${baseURL}/api/validation-rules/generate/`,
      body
    );
  },
  // Data Quality Insights – File Load Details API
  getFileLoadDetails: () => {
    return axiosInstance.get(`${baseURL}/api/data_quality/file-load-details/`);
  },
  // Bedrock Agent – Chat Message API
  sendBedrockAgentMessage: (message, sessionId) => {
    return axiosInstance.post(`${baseURL}/api/bedrock_agent/chat_message/`, {
      message: message,
      session_id: sessionId,
    });
  },

  // DQH Batch Assistant APIs
  sendBatchAssistantMessage: (
    message,
    sessionId,
    wizardState = {},
    currentStep = -1,
    silent = false
  ) => {
    return axiosInstance.post(`${baseURL}/api/bedrock_agent/batch_assistant/`, {
      message: message,
      session_id: sessionId,
      wizard_state: wizardState,
      current_step: currentStep,
      silent: silent,
    });
  },
  clearBatchSession: sessionId => {
    return axiosInstance
      .post(
        `${baseURL}/api/bedrock_agent/clear_session/`,
        { session_id: sessionId },
        { timeout: 5000 }
      )
      .catch(() => {}); // Non-critical, swallow errors
  },

  // ============= Genie (Databricks) API =============

  // Check if Databricks is configured via environment variables
  genieConnectionStatus: () => {
    return axiosInstance.get(`${baseURL}/api/genie/connection/status/`);
  },

  // Test connection to Databricks (manual credentials)
  genieTestConnection: (workspaceUrl, token) => {
    return axiosInstance.post(`${baseURL}/api/genie/connection/test/`, {
      workspace_url: workspaceUrl,
      token: token,
    });
  },

  // List all Genie spaces
  genieListSpaces: (workspaceUrl, token) => {
    return axiosInstance.get(`${baseURL}/api/genie/spaces/`, {
      headers: {
        'X-Workspace-Url': workspaceUrl,
        'X-Token': token,
      },
    });
  },

  // Get space details
  genieGetSpace: (workspaceUrl, token, spaceId) => {
    return axiosInstance.get(`${baseURL}/api/genie/spaces/${spaceId}/`, {
      headers: {
        'X-Workspace-Url': workspaceUrl,
        'X-Token': token,
      },
    });
  },

  // List conversations in a space
  genieListConversations: (workspaceUrl, token, spaceId) => {
    return axiosInstance.get(
      `${baseURL}/api/genie/conversations/space/${spaceId}/`,
      {
        headers: {
          'X-Workspace-Url': workspaceUrl,
          'X-Token': token,
        },
      }
    );
  },

  // Start a new conversation
  genieStartConversation: (workspaceUrl, token, spaceId, initialMessage) => {
    return axiosInstance.post(
      `${baseURL}/api/genie/conversations/`,
      {
        space_id: spaceId,
        initial_message: initialMessage,
      },
      {
        headers: {
          'X-Workspace-Url': workspaceUrl,
          'X-Token': token,
        },
      }
    );
  },

  // List messages in a conversation
  genieListMessages: (workspaceUrl, token, conversationId, spaceId) => {
    return axiosInstance.get(
      `${baseURL}/api/genie/conversations/${conversationId}/messages/?space_id=${spaceId}`,
      {
        headers: {
          'X-Workspace-Url': workspaceUrl,
          'X-Token': token,
        },
      }
    );
  },

  // Send a message to an existing conversation
  genieSendMessage: (workspaceUrl, token, conversationId, spaceId, content) => {
    return axiosInstance.post(
      `${baseURL}/api/genie/conversations/${conversationId}/messages/?space_id=${spaceId}`,
      { content: content },
      {
        headers: {
          'X-Workspace-Url': workspaceUrl,
          'X-Token': token,
        },
      }
    );
  },

  // Delete a conversation
  genieDeleteConversation: (workspaceUrl, token, conversationId, spaceId) => {
    return axiosInstance.delete(
      `${baseURL}/api/genie/conversations/${conversationId}/?space_id=${spaceId}`,
      {
        headers: {
          'X-Workspace-Url': workspaceUrl,
          'X-Token': token,
        },
      }
    );
  },

  // Send feedback for a message
  genieSendFeedback: (
    workspaceUrl,
    token,
    conversationId,
    messageId,
    spaceId,
    feedback
  ) => {
    return axiosInstance.post(
      `${baseURL}/api/genie/conversations/${conversationId}/messages/${messageId}/feedback/?space_id=${spaceId}`,
      { feedback: feedback },
      {
        headers: {
          'X-Workspace-Url': workspaceUrl,
          'X-Token': token,
        },
      }
    );
  },

  // Execute a quick query
  genieExecuteQuery: (workspaceUrl, token, spaceId, query) => {
    return axiosInstance.post(
      `${baseURL}/api/genie/query/`,
      {
        space_id: spaceId,
        query: query,
      },
      {
        headers: {
          'X-Workspace-Url': workspaceUrl,
          'X-Token': token,
        },
      }
    );
  },

  // Direct File Upload APIs (MFU)
  validateUpload: formData => {
    return axiosInstance.post(`${baseURL}/api/upload/validate/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  initUpload: body => {
    return axiosInstance.post(`${baseURL}/api/upload/init/`, body);
  },
  processUpload: bodyOrFormData => {
    const isFormData =
      typeof FormData !== 'undefined' && bodyOrFormData instanceof FormData;
    return axiosInstance.post(
      `${baseURL}/api/storage/get-json/?storage_type=MFU`,
      bodyOrFormData,
      isFormData
        ? {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        : undefined
    );
  },
  completeUpload: body => {
    return axiosInstance.post(`${baseURL}/api/upload/complete/`, body);
  },
  abortUpload: body => {
    return axiosInstance.post(`${baseURL}/api/upload/abort/`, body);
  },

  // DP Service - Get columns by services
  getColumnsByServices: body => {
    return axiosInstance.post(
      `${baseURL}/api/dp_service/get_columns_by_services/`,
      body
    );
  },

  // DQH - Download status report from S3
  downloadStatusReport: (s3Path, jobName) => {
    return axiosInstance.get(`${baseURL}/api/dqh/download-report/`, {
      params: { path: s3Path, jobName: jobName },
      responseType: 'blob',
    });
  },
};

export default api;

// =============================================================================
// Genie APIs (use existing axiosInstance)
// =============================================================================

const GENIE_PREFIX = '/api/genie';

// Use async (202 + poll) when not on localhost so proxy timeouts don't drop the response
const useGenieAsync =
  !baseURL || baseURL === '' || !baseURL.toLowerCase().includes('localhost');

// API functions
export const connectionAPI = {
  test: data =>
    axiosInstance
      .post(`${GENIE_PREFIX}/connection/test/`, data)
      .then(res => res.data),
};

export const spacesAPI = {
  // URL shape matches curl: `${baseURL}/api/genie/spaces/:id/`
  list: () =>
    axiosInstance.get(`${GENIE_PREFIX}/spaces/`).then(res => res.data),

  get: spaceId =>
    axiosInstance
      .get(`${GENIE_PREFIX}/spaces/${spaceId}/`)
      .then(res => res.data),

  create: (title, description) =>
    axiosInstance
      .post(`${GENIE_PREFIX}/spaces/`, { title, description })
      .then(res => res.data),

  update: (spaceId, title, description) =>
    axiosInstance
      .patch(`${GENIE_PREFIX}/spaces/${spaceId}/`, { title, description })
      .then(res => res.data),
};

export const conversationsAPI = {
  list: spaceId =>
    axiosInstance
      .get(`${GENIE_PREFIX}/conversations/space/${spaceId}/`)
      .then(res => res.data),

  start: (spaceId, initialMessage) =>
    axiosInstance
      .post(
        `${GENIE_PREFIX}/conversations/`,
        { space_id: spaceId, initial_message: initialMessage },
        { params: useGenieAsync ? { async: '1' } : {} }
      )
      .then(res => res.data),

  listMessages: (conversationId, spaceId) =>
    axiosInstance
      .get(`${GENIE_PREFIX}/conversations/${conversationId}/messages/`, {
        params: { space_id: spaceId },
      })
      .then(res => res.data),

  /** Poll after 202 from start/send; returns full result when status is COMPLETED/FAILED */
  getMessage: (conversationId, messageId, spaceId) =>
    axiosInstance
      .get(
        `${GENIE_PREFIX}/conversations/${conversationId}/messages/${messageId}/`,
        { params: { space_id: spaceId } }
      )
      .then(res => res.data),

  sendMessage: (conversationId, spaceId, content) =>
    axiosInstance
      .post(
        `${GENIE_PREFIX}/conversations/${conversationId}/messages/`,
        { content },
        {
          params: {
            space_id: spaceId,
            ...(useGenieAsync ? { async: '1' } : {}),
          },
        }
      )
      .then(res => res.data),

  delete: (conversationId, spaceId) =>
    axiosInstance
      .delete(`${GENIE_PREFIX}/conversations/${conversationId}/`, {
        params: { space_id: spaceId },
      })
      .then(res => res.data),

  sendFeedback: (conversationId, messageId, spaceId, feedback) =>
    axiosInstance
      .post(
        `${GENIE_PREFIX}/conversations/${conversationId}/messages/${messageId}/feedback/`,
        null,
        { params: { space_id: spaceId, feedback } }
      )
      .then(res => res.data),
};

export const queryAPI = {
  execute: (spaceId, query) =>
    axiosInstance
      .post(`${GENIE_PREFIX}/query/`, { space_id: spaceId, query })
      .then(res => res.data),
};
